import { formatINR } from "@/lib/format";

/** Profit & Loss statement grouped by ledger sections for the selected period. */
export function ProfitLossStatement({ pnl }) {
  if (!pnl) return null;
  const { income, expense, net } = pnl;
  const profit = net >= 0;
  return (
    <section className="border border-[#D8D4C7] bg-white" data-testid="pnl-statement">
      <div className="border-b border-[#1A1F16] px-6 py-4">
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#6C7565]">Statement</div>
        <h3 className="font-serif text-3xl tracking-tight">Profit &amp; Loss.</h3>
      </div>

      <LedgerBlock title="Income" data={income} accent="#2E6F40" testid="pnl-income" />
      <LedgerBlock title="Expenses" data={expense} accent="#D94F3D" testid="pnl-expense" />

      <div className="flex items-center justify-between px-6 py-5 bg-[#1A1F16] text-[#F7F5F0]">
        <span className="font-mono text-[11px] tracking-[0.25em] uppercase">
          {profit ? "Net Profit" : "Net Loss"}
        </span>
        <span className={`font-serif text-3xl num ${profit ? "text-[#8FD19E]" : "text-[#F0A79C]"}`} data-testid="pnl-net">
          {profit ? "+" : "−"} {formatINR(Math.abs(net))}
        </span>
      </div>
    </section>
  );
}

function LedgerBlock({ title, data, accent, testid }) {
  return (
    <div className="px-6 py-5 border-b border-[#EAE7DD]" data-testid={testid}>
      <div className="flex items-center justify-between mb-3">
        <span className="font-mono text-[11px] tracking-[0.25em] uppercase" style={{ color: accent }}>{title}</span>
        <span className="font-serif text-xl num">{formatINR(data.total)}</span>
      </div>
      {data.groups.length === 0 ? (
        <p className="text-sm text-[#6C7565] italic">No {title.toLowerCase()} recorded in this period.</p>
      ) : (
        <div className="space-y-4">
          {data.groups.map((g) => (
            <div key={g.ledger} data-testid={`ledger-${g.ledger.replace(/\s+/g, "-").toLowerCase()}`}>
              <div className="flex items-center justify-between border-b border-dashed border-[#D8D4C7] pb-1 mb-1">
                <span className="text-sm font-medium">{g.ledger}</span>
                <span className="num text-sm font-medium">{formatINR(g.total)}</span>
              </div>
              {g.categories.map((c) => (
                <div key={c.category} className="flex items-center justify-between pl-4 py-0.5 text-sm text-[#4A5142]">
                  <span>{c.category}</span>
                  <span className="num text-[#6C7565]">{formatINR(c.amount)}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
